



























































import Vue from 'vue';
import dayjs from 'dayjs';
import 'dayjs/locale/pt-br';
dayjs.locale('pt-br');

import { Integration } from '@/models';

export default Vue.extend({
  props: {
    bots: {
      type: Array,
    },
    botsCount: {
      type: Number,
    },
    isMobile: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    const initialOptions = {
      sortDesc: [true],
      sortBy: ['createdAt'],
      itemsPerPage: 10,
      page: 1,
    };
    return {
      headers: [
        { text: 'Título', value: 'title', align: 'left', width: '270px' },
        { text: 'Status', value: 'status', align: 'left', width: '110px' },
        { text: 'Criada em', value: 'createdAt', align: 'left', width: '110px' },
      ],
      lastOptions: initialOptions,
      options: { ...initialOptions },
    };
  },
  methods: {
    formatDate(date: string) {
      return dayjs(date).format('DD MMM YYYY');
    },
    viewItem(item: Integration) {
      this.$router.push(`/bots/${item.objectId}`);
    },
  },
});
